import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-text-column-molecule',
  templateUrl: './text-column-molecule.component.html',
  styleUrls: ['./text-column-molecule.component.scss']
})
export class TextColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
}
